var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex h-13" }, [
    _c("div", { staticClass: "flex pl-6 bg-slate-100 sticky left-88 z-10" }, [
      _c(
        "div",
        {
          staticClass:
            "flex items-center border-b border-l border-r border-slate-400 bg-pure-white",
          class: { "rounded-bl": _vm.isLast }
        },
        [
          _c(
            "div",
            { staticClass: "w-20 px-4 flex flex-shrink-0 gap-2" },
            [
              _c("BlTextBody2", {
                staticClass: "truncate text-slate-1000",
                attrs: { text: _vm.item.id }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-60 px-4 flex flex-shrink-0 gap-2",
              attrs: { title: _vm.item.client.name }
            },
            [
              _c("BlTextBody2", {
                staticClass: "truncate text-slate-1000",
                attrs: { text: _vm.item.client.name }
              })
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "w-30 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
      },
      [_c("BlChip", { attrs: { chip: _vm.item.status } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "w-40 pl-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
      },
      [_c("BlTextBody2", { attrs: { text: _vm.displayDate(_vm.item.date) } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "w-40 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
      },
      [
        _c("BlTextBody2", {
          attrs: {
            text: _vm.item.start_time_string + " - " + _vm.item.end_time_string
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.enableBranch
      ? _c(
          "div",
          {
            staticClass:
              "w-50 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
          },
          [
            !_vm.item.room || !_vm.item.room.branch
              ? _c("BlTextBody2", { attrs: { text: "-" } })
              : _c(
                  "div",
                  {
                    staticClass:
                      "h-7 max-w-44 px-2 flex items-center justify-center rounded",
                    style: {
                      backgroundColor:
                        _vm.item.room.branch.background_color || "unset"
                    },
                    attrs: { title: _vm.item.room.branch.name }
                  },
                  [
                    _c("BlTextBody2", {
                      staticClass: "truncate",
                      style: {
                        color: _vm.item.room.branch.color || "unset"
                      },
                      attrs: { text: _vm.item.room.branch.name || "-" }
                    })
                  ],
                  1
                )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.enableAppointment
      ? _c(
          "div",
          {
            staticClass:
              "w-50 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
          },
          [
            !_vm.item.room
              ? _c("BlTextBody2", {
                  staticClass: "truncate",
                  attrs: { text: "-" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("BlTextBody2", {
              staticClass: "truncate",
              attrs: { text: _vm.item.room.name, title: _vm.item.room.name }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "w-80 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
      },
      [
        _vm.item.supervisors.length
          ? _c("BlTextBody2", {
              staticClass: "truncate",
              attrs: {
                text: _vm.item.supervisors
                  .map(function(i) {
                    return i.name
                  })
                  .join(", "),
                title: _vm.item.supervisors
                  .map(function(i) {
                    return i.name
                  })
                  .join(", ")
              }
            })
          : _c("BlTextBody2", { attrs: { text: "-" } })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex pr-6 bg-slate-100 sticky right-0",
        style: { zIndex: 1 }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "w-50 px-4 flex-shrink-0 bg-pure-white flex-grow flex items-center justify-end border-b border-r border-slate-400",
            class: { "rounded-br": _vm.isLast }
          },
          [
            _vm.item.status === "scheduled"
              ? _c(
                  "router-link",
                  {
                    staticClass: "cursor-pointer",
                    attrs: {
                      title: "View session draft",
                      to: "/session/" + _vm.item.session.slug + "/edit"
                    }
                  },
                  [
                    _c("BlInputButton", {
                      attrs: {
                        type: "outlined",
                        dense: "",
                        label: "View session draft"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.item.status === "in_progress"
              ? _c(
                  "router-link",
                  {
                    staticClass: "cursor-pointer",
                    attrs: {
                      title: "Resume session",
                      to: "/session/" + _vm.item.session.slug
                    }
                  },
                  [
                    _c("BlInputButton", {
                      attrs: {
                        type: "outlined",
                        dense: "",
                        label: "Resume session"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.item.status === "completed" || _vm.item.status === "cancelled"
              ? _c(
                  "router-link",
                  {
                    staticClass: "cursor-pointer",
                    attrs: {
                      title: "View session",
                      to: "/session/" + _vm.item.session.slug
                    }
                  },
                  [
                    _c("BlInputButton", {
                      attrs: {
                        type: "outlined",
                        dense: "",
                        label: "View session"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bf3535a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf3535a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mySessions/table/Item.vue
// module id = null
// module chunks = 